"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _tool = require("@entrylabs/tool");
var LearningChart = exports["default"] = /*#__PURE__*/function () {
  function LearningChart(modalData) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'chart';
    (0, _classCallCheck2["default"])(this, LearningChart);
    if (type === 'tree') {
      this.modal = this.createTree(modalData);
    } else {
      this.modal = this.createChart(modalData);
    }
    this.modal.show();
  }
  return (0, _createClass2["default"])(LearningChart, [{
    key: "show",
    value: function show() {
      this.modal.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.modal.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.modal.hide();
      this.modal = null;
    }
  }, {
    key: "load",
    value: function load(data) {
      this.modal.setData(data);
    }
  }, {
    key: "createChart",
    value: function createChart(_ref) {
      var _ref$title = _ref.title,
        title = _ref$title === void 0 ? '' : _ref$title,
        _ref$description = _ref.description,
        description = _ref$description === void 0 ? '' : _ref$description,
        source = _ref.source;
      var container = Entry.Dom('div', {
        "class": 'entry-learning-chart',
        parent: $(Entry.modalContainer)
      })[0];
      return new _tool.BillBoard({
        data: {
          source: source,
          title: title,
          description: description,
          togglePause: function togglePause() {
            return Entry.engine.togglePause();
          },
          stop: function stop() {
            return Entry.engine.toggleStop();
          },
          isIframe: self !== top
        },
        container: container
      });
    }
  }, {
    key: "createTree",
    value: function createTree(_ref2) {
      var _ref2$title = _ref2.title,
        title = _ref2$title === void 0 ? '' : _ref2$title,
        source = _ref2.source;
      var container = Entry.Dom('div', {
        "class": 'entry-learning-chart',
        parent: $(Entry.modalContainer)
      })[0];
      return new _tool.Tree({
        data: {
          source: source,
          title: title,
          togglePause: function togglePause() {
            return Entry.engine.togglePause();
          },
          stop: function stop() {
            return Entry.engine.toggleStop();
          },
          isIframe: self !== top
        },
        container: container
      });
    }
  }]);
}();